import React from 'react';
import classnames from 'classnames';
import type { UAPPlacementComponentProps } from '../@types';
import { PlacementText } from './placement-text';
import { PlacementAction } from './placement-action';

export const DescriptionWithAction = ({
  isMultiLine,
  description,
  descriptionWithActionClassName,
  placementDescriptionClassName,
  placementCallToActionClassName,
  placementCallToActionAsLinkClassName,
  showCallToActionAsLink,
  callToAction,
}: UAPPlacementComponentProps) => (
  <div className={descriptionWithActionClassName}>
    <PlacementText

      isMultiLine={isMultiLine}
      text={description}
      placementTextClassName={classnames(placementDescriptionClassName)}
    />
    {callToAction && <PlacementAction actionText={callToAction.replace(/([A-Z])/g, ' $1')} placementActionClassName={classnames(placementCallToActionClassName, showCallToActionAsLink && placementCallToActionAsLinkClassName)} />}
  </div>
);
